/**
 * 
 * @author Iecisa
 */
export class ForgotPasswordDTO {
    email: string;
}
